<template>
  <div class="credit-card--wrapper">
    <div class="credit-card" :class="{'main-card': data.isMain()}" @click="handleClick">
      <div class="brand-logo">
        <i :class="data.getBrandIconClass()"></i>
      </div>
      <div class="holder-name">
        {{data.getHolderName()}}
      </div>
      <div class="card-input-wrapper">
        <div class="card-input-group">
          <span class="label">{{$t('credit-card.cardNumber')}}</span>
          <div class="value">
            <span>XXXX XXXX XXXX {{data.getLast4()}}</span>
          </div>
        </div>
        <div class="card-input-group">
          <span class="label">{{$t('credit-card.expiration')}}</span>
          <div class="value">
            <span>{{data.getExpiration()}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="credit-card--actions" v-if="!data.isMain()">
      <button class="card-btn" @click="setMain(data.getId())">Utiliser cette carte</button>
      <button class="card-btn" @click="deleteCard(data.getId())">{{$t('credit-card.delete')}}</button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'credit-card',
  props: ['data'],
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
    setMain(id) {
      this.$store.dispatch('stripeCard/setMain', id);
    },
    deleteCard(id) {
      this.$store.dispatch('stripeCard/deleteCard', id);
    },
  },
};
</script>

<style scoped>
  .credit-card--wrapper {
    margin-bottom: 1rem;
  }
  .credit-card {
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 1rem;
    position: relative;
    min-height: 32px;
    z-index: 2;
  }
  .credit-card--actions {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    background: var(--red);
    margin-top: -8px;
    padding-top: 8px;
    height: 40px;
    transition: all 300ms ease;
    position: relative;
    z-index: 1;
    display: flex;
  }
  .credit-card--actions .card-btn {
    flex: 1 1 auto;
    background: transparent;
    color: #fff;
    border: none;
    margin-top: -8px;
    padding-top: 8px;
    font-size: 16px;
    cursor: pointer;

    transition: all 300ms ease;
  }
  .credit-card--actions .card-btn:hover {
    background: #fff;
    color: var(--red);
  }
  .credit-card.main-card ~ .credit-card--actions .card-btn {
    flex: 1 1 auto;
    background: transparent;
    color: var(--red);
  }
  .credit-card.main-card ~ .credit-card--actions .card-btn:hover {
    background: var(--red);
    color: #fff;
  }
  .credit-card.main-card ~ .credit-card--actions {
    background: #fff;
  }
  .credit-card.main-card {
    background: var(--red);
    transition: all 1s ease;
    color: #fff;
  }
  .cardit-card:last-child {
    margin-bottom: 0;
  }
  .credit-card .brand-logo {
    position: absolute;
    right: 1rem;
    top: .5rem;
    font-size: 32px;
  }
  .card-input-group {
    margin: 1rem 0 0 0;
  }
  .card-input-group .label {
    opacity: .5;
    font-size: .7em;
    display: block;
  }
  .card-input-group .value {
    margin-top: .5rem;
    background: rgba(0, 0, 0, 0.06);
    padding: 7px 2rem;
    display: inline-block;
  }
  .credit-card.main-card .card-input-group .value {
    background: rgba(255, 255, 255, 0.1);
  }
  .card-input-wrapper {
    display: grid;
    grid-template: "1fr 1fr";
  }
</style>



// WEBPACK FOOTER //
// src/components/credit-card.vue